const STORAGE_KEY = 'multirx-saisons-standings-division';

export function readStoredStandingsDivision(): number {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const id = raw ? parseInt(raw, 10) : 1;
    return id >= 1 && id <= 4 ? id : 1;
  } catch {
    return 1;
  }
}

export function storeStandingsDivision(divisionId: number): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(divisionId));
  } catch {
    /* sessionStorage indisponible */
  }
}
